<div class="col-lg-4 col-md-6" *ngFor="let project of projects">
    <div class="blog-item">
        <div class="blog-image">
            <a routerLink="/projects-details/{{project.id}}">
                <img src="{{environment.ImageApiPath +'/'+ this.project?.attachment?.name}}" alt="{{project?.name}}">
            </a>
        </div>
        <div class="single-blog-item">
            <ul class="blog-list">
                <li><a routerLink="/"><i class="fas fa-calendar-week"></i> {{project.createdDate |date:"dd-MM-yyyy"}}</a></li>
            </ul>
            <div class="blog-content">
                <h3><a routerLink="/projects-details/{{project.id}}">{{project.name}}</a></h3>
                <p [innerHTML]="project.descrption.substring(0,80)">.</p>
                <div class="blog-btn">
                    <a routerLink="/projects-details/{{project.id}}" class="blog-btn-one">Read More <i class="fa fa-chevron-right"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>
